import { Purchase } from "types";
import { validateParams } from "../hookHelpers";
import { ResourceFetchOptions, useResource } from "../useResource";

export const usePurchase = (
    purchaseId: string | undefined | null,
    params: any = null,
    options: ResourceFetchOptions<Purchase> = {},
) => {
    params = validateParams(params);

    const response = useResource<Purchase>(["purchases", purchaseId], params, options);
    return { ...response, purchase: response.data, isLoadingPurchase: response.isLoading };
};
